import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Catering from './pages/Catering';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import OurStory from './pages/OurStory';
import OrderTerms from './pages/OrderTerms';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Accessibility from './pages/Accessibility';
import PrivateEvents from './pages/PrivateEvents';
import Reservations from './pages/Reservations';
import GiftCards from './pages/GiftCards';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/catering" element={<Catering />} />
            <Route path="/were-hiring" element={<Careers />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/private-events" element={<PrivateEvents />} />
            <Route path="/reservations" element={<Reservations />} />
            <Route path="/gift-cards" element={<GiftCards />} />
            <Route path="/order-terms" element={<OrderTerms />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/accessibility" element={<Accessibility />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
